import { render, staticRenderFns } from "./modalEditTenantDashboard.vue?vue&type=template&id=39354d30&"
import script from "./modalEditTenantDashboard.vue?vue&type=script&lang=js&"
export * from "./modalEditTenantDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports